export const getCustomerTypePrefixAndSuffix = (customer_type) => {
  const customerTypePrefixAndSuffix = {
    prefix: "",
    suffix: "",
  };
  switch (customer_type) {
    case "ร้านค้า":
      customerTypePrefixAndSuffix.prefix = "ร้านค้า";
      customerTypePrefixAndSuffix.suffix = "";
      break;
    case "บริษัทจำกัด":
      customerTypePrefixAndSuffix.prefix = "บริษัท";
      customerTypePrefixAndSuffix.suffix = "จำกัด";
      break;
    case "ห้างหุ้นส่วนจำกัด":
      customerTypePrefixAndSuffix.prefix = "ห้างหุ้นส่วน";
      customerTypePrefixAndSuffix.suffix = "จำกัด";
      break;
    case "บริษัทมหาชนจำกัด":
      customerTypePrefixAndSuffix.prefix = "บริษัทมหาชน";
      customerTypePrefixAndSuffix.suffix = "จำกัด";
      break;
    default:
      customerTypePrefixAndSuffix.prefix = "อื่นๆ";
      customerTypePrefixAndSuffix.suffix = "";
      break;
  }

  return customerTypePrefixAndSuffix;
};
